import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { MDBBadge, MDBCol, MDBIcon } from "mdbreact";
import { currency, fullName } from "../../../../services/utilities";
import { Privileges } from "../../../../services/fakeDb";
import {
  SetHealthCardContribution,
  SetPrivilege,
} from "../../../../services/redux/slices/diagnostics/clinic/settlements";
import {
  getAppointmentMeta,
  getHealthCardCoverage,
  getHealthCardKey,
  getHealthCardLabel,
  getPatientHealthCards,
  getSelectedClinic,
} from "./utils";

export default function ClientPanel() {
  const dispatch = useDispatch();
  const { selectedAppointment = null } = useSelector(
    ({ clinicalBilling }) => clinicalBilling,
  );
  const {
    cart = [],
    privilege = 0,
    healthCardContributions = {},
  } = useSelector(({ settlements }) => settlements);

  const clinic = getSelectedClinic(selectedAppointment);
  const { physicianName, scheduleLabel, queueNumber, healthCardSummary } =
    getAppointmentMeta(selectedAppointment);
  const patientHealthCards = getPatientHealthCards(
    selectedAppointment?.patient,
  );
  const net = Array.isArray(cart)
    ? cart.reduce((sum, item) => {
        const qty = Number(item?.qty || 0);
        const srp = Number(item?.srp || item?.price || item?.opd || 0);
        return sum + qty * srp;
      }, 0)
    : 0;
  const coverage = getHealthCardCoverage({
    cards: patientHealthCards,
    contributions: healthCardContributions,
    net,
  });

  return (
    <MDBCol md="4" className="mb-4">
      <div className="border rounded p-3 h-100 bg-white">
        {selectedAppointment ? (
          <>
            <div className="font-weight-bold text-uppercase small text-muted mb-3">
              Client
            </div>
            <div className="d-flex flex-wrap align-items-start justify-content-between mb-3">
              <div>
                <div className="font-weight-bold">
                  {fullName(selectedAppointment?.patient?.fullName)}
                </div>
                <div className="text-muted small">
                  {clinic?.title || "Select a confirmed appointment first"}
                </div>
              </div>
              <div style={{ minWidth: "150px" }}>
                <MDBBadge color="primary" className="mb-2">
                  Confirmed Appointment
                </MDBBadge>
                <select
                  value={privilege}
                  onChange={({ target }) =>
                    dispatch(SetPrivilege(Number(target.value)))
                  }
                  className="form-control form-control-sm"
                >
                  {Privileges.map((item, index) => (
                    <option key={item} value={index}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="small text-muted mb-3">
              <div>Doctor: {physicianName ? `Dr. ${physicianName}` : "--"}</div>
              <div>Schedule: {scheduleLabel}</div>
              <div>Queue No: {queueNumber}</div>
            </div>

            <div className="small font-weight-bold text-dark mb-2">
              Health Card Coverage
            </div>
            {patientHealthCards.length ? (
              <>
                {patientHealthCards.map((card, index) => {
                  const key = getHealthCardKey(card, index);

                  return (
                    <div key={key} className="d-flex align-items-center mb-2">
                      <div className="small text-dark flex-grow-1">
                        {getHealthCardLabel(card)}
                      </div>

                      <input
                        type="number"
                        min="0"
                        max={net || 0}
                        value={String(healthCardContributions[key] || 0)}
                        onChange={({ target }) =>
                          dispatch(
                            SetHealthCardContribution({
                              key,
                              value: target.value,
                            }),
                          )
                        }
                        placeholder="0"
                        className="form-control form-control-sm text-right"
                        style={{ width: "120px" }}
                      />
                    </div>
                  );
                })}
                <div className="text-right text-dark font-weight-bold mt-3">
                  Coverage: {currency.format(coverage)}
                </div>
              </>
            ) : (
              <div className="small text-muted">{healthCardSummary}</div>
            )}
          </>
        ) : (
          <div className="text-center text-muted py-5">
            <MDBIcon icon="user-injured" size="2x" className="mb-3" />
            <div>Select a confirmed appointment.</div>
          </div>
        )}
      </div>
    </MDBCol>
  );
}
